import React from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import { ShadowDom } from './components/ShadowDom';
import { LocationRow } from './components/locationRow';

const LocationList = ({
  locations = [],
  editAction,
  deleteAction,
  locationsLoading,
  voiceAction,
  centerAction,
  isVoiceAccount,
  callCenterLicense,
}) => {
  const Row = ({ index, style }) => {
    return (
      <LocationRow
        key={index}
        locationItem={locations[index]}
        voiceAction={voiceAction}
        callCenterLicense={callCenterLicense}
        centerAction={centerAction}
        isVoiceAccount={isVoiceAccount}
        editAction={editAction}
        deleteAction={deleteAction}
        style={style}
      />
    );
  };

  return (
    <>
      {locationsLoading && <ShadowDom />}
      <AutoSizer defaultWidth="100%">
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            className="m-user-list"
            itemCount={locations.length}
            itemSize={71}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </>
  );
};

export default LocationList;
